<template>
  <v-icon :class="iconStyles" v-text="icon" />
</template>

<script>
export default {
  name: 'CreativeAuditIcon',
  props: {
    creative: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      if (this.creative.hasWarning) {
        return 'warning'
      } else if (this.creative.hasNotice) {
        return 'information'
      } else {
        return ''
      }
    },
    iconStyles() {
      return {
        'yellow--text text--darken-2': this.creative.hasWarning,
        'info--text text--lighten-1':
          !this.creative.hasWarning && this.creative.hasNotice,
      }
    },
  },
}
</script>

<style></style>
